import { fetcher } from '@commenda/utils';

export async function toggleMessagePin(chatRoomId: string, messageId: string) {
  const res = await fetcher(
    `chatRoom/${chatRoomId}/message/${messageId}/toggle-pin`,
    { method: 'POST' }
  );

  return res;
}
